import { useNavigate } from 'react-router-dom';
import type { VaultItem } from '@heybesafe/shared';
import { maskedCardNumber } from '@heybesafe/shared';
import { HbsListRow } from './hbs/ListRow';
import { Icon } from './hbs/Icon';
import { cardBrandLabel } from '../lib/cardBrandLabel';

interface CardRowProps {
  item: VaultItem;
  /** Highlights the row for route-based selection. */
  selected?: boolean;
}

/** One payment-card row in the My Payment Cards list. Title is the card's
 *  name; supporting line is brand + `•••• last4`. Cards are treated as
 *  sensitive throughout — the masked number (last-4 only) is all that shows
 *  here, never the full PAN. */
export function CardRow({ item, selected }: CardRowProps): JSX.Element {
  const navigate = useNavigate();
  const masked = maskedCardNumber(item.cardNumber ?? '');
  const brand = cardBrandLabel(item.cardBrand);
  const supporting = [brand, masked].filter(Boolean).join(' · ');

  return (
    <HbsListRow
      id={`card-row-${item.id}`}
      leading={<Icon name="card" size={22} className="text-hbs-text-mute" />}
      title={item.name}
      supporting={supporting}
      selected={selected}
      onClick={() => navigate(`/cards/${item.id}`)}
      actions={
        <button
          id={`card-view-${item.id}`}
          type="button"
          aria-label="View"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/cards/${item.id}`);
          }}
          className="p-1.5 rounded-hbs-sm text-hbs-text-mute hover:text-hbs-text hover:bg-hbs-surface-alt"
        >
          <Icon name="view" size={14} />
        </button>
      }
    />
  );
}
